export function isSurveyCreditBlocked(survey) {
    return survey?.credit_state === "HIGH_UNPAID";
}
